import { Link, useLocation, useNavigate } from "react-router-dom";
import "./App.css";
import { enToTr } from "./utils/urlMap";
import mainLogo from "./assets/teknokent_clip.png";

import polsanLogo from "./assets/polsan-logo.png";

function HeaderEng() {
  const location = useLocation();
  const navigate = useNavigate();

  const changeToTR = () => {
    const next = enToTr[location.pathname] || "/";
    navigate(next);
  };

  return (
    <header class="header">
      <nav class="navbar navbar-expand-lg bg-body-tertiary header-main">
        <div class="container-fluid">
          <Link to="/"><img src={mainLogo} alt="Polsan Logo" className="navbar-brand d-inline-block align-text-top logo-img" /></Link>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0 ms-lg-5">
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  About Us
                </a>
                <ul class="dropdown-menu sub-menu">
                  <li><a class="dropdown-item" href="/en/about-us">POLSAN Science and Technology Park</a></li>
                  <li><a class="dropdown-item" href="/en/partnership-structure">Partnership Structure</a></li>
                  <li><a class="dropdown-item" href="/en/board-of-directors">Board of Directors</a></li>
                  <li><a class="dropdown-item" href="/en">Company Management</a></li>
                </ul>
              </li>
              {/* <li class="nav-item nav-link">
                <Link to="/en">Companies</Link>
              </li> */}
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Corporate
                </a>
                <ul class="dropdown-menu sub-menu">
                  <li><a class="dropdown-item" href="/en/tto">TTO</a></li>
                  <li><a class="dropdown-item" href="/en/entrepreneurship">Entrepreneurship</a></li>
                  <li><a class="dropdown-item" href="/en/collaboration">University - Industry Collaboration</a></li>
                  <li><a class="dropdown-item" href="/en/clusters">Clusters</a></li>
                </ul>
              </li>
              <li class="nav-item nav-link">
                <Link to="/en/media">Media</Link>
              </li>
              <li class="nav-item nav-link">
                <Link to="/en/contact-us">Contact Us</Link>
              </li>
            </ul>
            <div class="nav-item nav-link me-2 p-2 basvuru-menu">
              <Link to="/en/application">Application</Link>
            </div>
            <button onClick={changeToTR} class="btn btn-sm me-2 btn-lng">
              TR / EN
            </button>
            <div class="d-flex">
              <a href="https://polsan.com.tr" class="p-2 btn-polsan-img" target="_blank"><img src={polsanLogo} alt="POLSAN Logo" class="polsan-logo" /></a>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default HeaderEng;
